import {addDeepLink} from 'app/components/textWithImageSSR/utils/addDeepLink';
import {addLazyScroll} from 'app/components/textWithImageSSR/utils/addLazyScroll';
import {type ShouldSkipLazyLoadFn, type ShouldSkipLazyLoadType} from 'app/interface';
import {getLoadingType} from 'app/utils/initialize/getLoadingType';
import {TextWithImageConfig} from 'interfaces/common/components/general/textwithimage/textWithImageConfig';

export const shouldSkipLazyLoad: ShouldSkipLazyLoadFn<TextWithImageConfig> = ({config}) => {
    if (!config) {
        throw new Error('Config is missing!');
    }

    const loadingTypes = new Set<ShouldSkipLazyLoadType>();

    // Other components e.g. toggle, in theirs shouldSkipLazyLoad script,
    // will try to find all links on page with the hash part because of the deep linking.
    // Because of that TWI must be rendered if its links contains hash part.
    const hashRe = /#[0-9a-z_-]+$/i;
    if (config.links?.link1?.linkPath && hashRe.test(config.links.link1.linkPath)) {
        loadingTypes.add('LOAD_EAGER');
    }

    if (config.links?.link2?.linkPath && hashRe.test(config.links.link2.linkPath)) {
        loadingTypes.add('LOAD_EAGER');
    }

    if (addLazyScroll(config.cId, config.text)) {
        loadingTypes.add('LOAD_EAGER_WITH_SCROLL_TO');
    }

    addDeepLink(config.cId, config.text);

    return getLoadingType(loadingTypes);
};

export const shouldSkipLazyLoadCompat: ShouldSkipLazyLoadFn = (params) => {
    return shouldSkipLazyLoad(params as Parameters<typeof shouldSkipLazyLoad>[0]);
};
